var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDeviceTrust1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.036,
    y1: 0.037,
    x2: 0.876,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9332c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00205d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3129",
    "data-name": "Rectangle 3129",
    width: 64,
    height: 64,
    transform: "translate(16292 1488)",
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_device_trust",
    transform: "translate(-16292 -1488)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9056",
    "data-name": "Group 9056",
    transform: "translate(16292 1491.568)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "devices-svgrepo-com_3_",
    "data-name": "devices-svgrepo-com (3)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_275",
    "data-name": "Union 275",
    d: "M46.66,56.846H17.338a2.972,2.972,0,0,1-.322.017,2.833,2.833,0,0,1-2.806-2.386,2.831,2.831,0,0,1,2.8-2.387,2.7,2.7,0,0,1,.325.019h6.349V47.371H4.737A4.742,4.742,0,0,1,0,42.633V4.737A4.741,4.741,0,0,1,4.737,0H59.261A4.742,4.742,0,0,1,64,4.737v37.9a4.744,4.744,0,0,1-4.737,4.738H40.312v4.738H46.66a2.706,2.706,0,0,1,.324-.019,2.831,2.831,0,0,1,2.8,2.387,2.832,2.832,0,0,1-2.805,2.386A2.964,2.964,0,0,1,46.66,56.846Zm12.6-14.213V4.737H4.737v37.9H59.261Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_181",
    "data-name": "Subtraction 181",
    d: "M12.222,30.074a1.262,1.262,0,0,1-.683-.209A42.268,42.268,0,0,1,4.83,25C1.623,22.062,0,19.217,0,16.542V4.1C0,3.493,12.1.035,12.222,0c.119.035,12.227,3.486,12.227,4.1V16.542c0,2.686-1.615,5.54-4.814,8.481A37.487,37.487,0,0,1,12.9,29.865,1.222,1.222,0,0,1,12.222,30.074ZM6.445,13.79c-.039,0-.062,0-.093,0a1.375,1.375,0,0,0-1.053.612,1.533,1.533,0,0,0,.153,1.98L9.09,19.978a1.382,1.382,0,0,0,2.04,0l8.021-8.063A1.505,1.505,0,0,0,19.014,10,1.466,1.466,0,0,0,17.1,9.86l-7,7.043-2.614-2.64A1.408,1.408,0,0,0,6.445,13.79Z",
    transform: "translate(19.778 8.84)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeviceTrust1);
export default __webpack_public_path__ + "static/media/ic_device_trust_1.e6dfcf098a20b5c93bfc9323f344d7b4.svg";
export { ForwardRef as ReactComponent };